export const shopStateKey = 'shop';
export const cartStateKey = 'cart';
export const requestStateKey = 'request';
